import React from 'react';
import PropTypes from 'prop-types';
import './Radio.scss';
import { createClassList } from '../../utils/dom/class';

const Radio = ({
  id,
  name,
  label,
  value,
  disabled,
  onChange,
  inputRef,
  hideLabel,
  checked,
  condensed,
  attributes,
  classes,
}) => {
  const handleChange = (e) => onChange(e.target.value);

  return (
    <div
      key={label}
      className={createClassList({
        default: [
          'axiom-radio-button-set radio-button-set',
          `${condensed ? 'condensed' : ''}`,
        ],
        custom: classes,
        required: [],
      })}
    >
      <input
        id={id}
        type='radio'
        data-testid='radio'
        name={name}
        value={value}
        disabled={disabled}
        onChange={handleChange}
        checked={checked}
        ref={inputRef}
        {...attributes}
      />
      <label
        htmlFor={id}
        className={hideLabel ? 'label_hidden' : null}
      >
        {label}
      </label>
    </div>
  );
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string, // @sic; can be on or off
  checked: PropTypes.bool, // changed to optional + default [MJ]
  disabled: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  hideLabel: PropTypes.bool,
  condensed: PropTypes.bool,
  attributes: PropTypes.objectOf(PropTypes.any),
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Radio.defaultProps = {
  value: undefined,
  checked: false, // changed to optional + default [MJ]
  disabled: false,
  inputRef: undefined,
  hideLabel: false,
  condensed: false,
  attributes: {},
  classes: [],
};

export default Radio;
